import {create} from "zustand";

interface LanguageState {
    currentLanguage: string,
}

interface LanguageStore extends LanguageState {
    setCurrentLanguage: (language: string) => void
}

export const useLanguageStore = create<LanguageStore>()((set) => ({
    currentLanguage: localStorage.getItem("lang") || "en",
    setCurrentLanguage: (language) => set({currentLanguage: language})
}));